import { useSyncExternalStore } from 'react'

/**
 * Global "Design mode" flag, toggled from the ask bar agent select.
 * Module-level store so the nav shell, document preview, and ask bar
 * can all react without prop threading.
 */
let designModeActive = false

/** @type {Set<() => void>} */
const listeners = new Set()

export function isDesignModeActive() {
  return designModeActive
}

/** @param {boolean} next */
export function setDesignModeActive(next) {
  const value = Boolean(next)
  if (designModeActive === value) return
  designModeActive = value
  for (const listener of listeners) listener()
}

/** @param {() => void} listener @returns {() => void} */
export function subscribeDesignMode(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** @returns {boolean} */
export function useDesignMode() {
  return useSyncExternalStore(subscribeDesignMode, isDesignModeActive)
}
